import { render, staticRenderFns } from "./cargoLaboral.vue?vue&type=template&id=46394f5b"
import script from "./cargoLaboral.vue?vue&type=script&lang=js"
export * from "./cargoLaboral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports